/**
 * @module lib/commercial/keytar/globe-advisor/template
 */
import Template, { BLOCKOUT_TYPES } from "lib/commercial/keytar/Template";
import defaultView from "./view-default";
import { isLoggedIn } from "lib/identity/api";
import { hideRootElements } from "lib/commercial/keytar/common/takeover";

const props = {
  blockoutType: BLOCKOUT_TYPES.PREVIEW,
  analytics: {
    adsVisible: true,
    countVisibleParagraphs: 1,
    viewType: "teaser"
  },
  /**
   * @method render
   * @description Always render the paywall template.
   * @returns {Promise<Boolean>} true if rendered
   */
  render() {
    defaultView(this.parentContext.contentType, this.parentContext.wallAnalyticsSchema, isLoggedIn());
    hideRootElements([".js-c-comments-toggle"]);
    return Promise.resolve(true);
  }
};

export default new Template(props);
